import { combineReducers } from 'redux';

import randomFeature from 'RandomFeature/reducer';

const reducers = combineReducers({
  randomFeature,
});

export default reducers;
